import { tickerItems } from "@/mocks/home";

export default function UpdateTicker() {
  const items = [...tickerItems, ...tickerItems];
  return (
    <div className="relative overflow-hidden border-b border-primary-800 bg-primary-700 text-background-50">
      <div className="mx-auto flex w-full max-w-[1280px] items-stretch">
        {/* label */}
        <div className="z-10 flex shrink-0 items-center gap-2 bg-primary-600 px-4 py-2.5 md:px-5">
          <span className="flex h-2 w-2 animate-pulseDot rounded-full bg-accent-400" />
          <span className="whitespace-nowrap text-sm font-bold tracking-wider">今日更新</span>
        </div>
        {/* marquee */}
        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max animate-ticker items-center">
            {items.map((it, i) => (
              <a
                key={`${it.time}-${i}`}
                href="#stream"
                className="flex items-center gap-2 whitespace-nowrap px-5 text-sm text-background-50/95 hover:text-background-50"
              >
                <span className="font-mono text-xs text-accent-300">{it.time}</span>
                {it.label}
                <span className="ml-2 text-background-50/30">/</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}